import { render } from "./CataLogResource.vue?vue&type=template&id=7dd717b5"
import script from "./CataLogResource.vue?vue&type=script&lang=js"
export * from "./CataLogResource.vue?vue&type=script&lang=js"

import "./CataLogResource.vue?vue&type=style&index=0&id=7dd717b5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__